import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Building2, Users, Shield, LogOut, ShieldCheck, MessageCircle } from 'lucide-react';

const NAV = [
  { to: '/supperadmin', label: 'Organizations', icon: Building2, end: true },
  { to: '/supperadmin/employees', label: 'Employees', icon: Users },
  { to: '/supperadmin/role-page-access', label: 'Role Page Access', icon: Shield },
  { to: '/supperadmin/whatsapp-logs', label: 'WhatsApp Logs', icon: MessageCircle },
];

/** Layout shell for the global platform-owner portal. */
export const SuperAdminLayout: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/supperadmin/login', { replace: true });
  };

  return (
    <div className="h-screen flex bg-gray-100 overflow-hidden">
      <aside className="w-60 bg-gray-900 text-gray-200 flex flex-col flex-shrink-0 h-full">
        <div className="px-5 py-5 flex items-center gap-2 border-b border-gray-800">
          <div className="h-9 w-9 rounded-xl bg-indigo-600 flex items-center justify-center">
            <ShieldCheck className="h-5 w-5 text-white" />
          </div>
          <div>
            <div className="text-sm font-bold text-white leading-tight">Platform Admin</div>
            <div className="text-[11px] text-gray-400">Restro360</div>
          </div>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {NAV.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-800'
                }`
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-gray-800">
          <div className="px-3 pb-2 text-[11px] text-gray-500 truncate">{user?.email || user?.name}</div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-red-300 hover:bg-gray-800"
          >
            <LogOut className="h-4 w-4" />
            Logout
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};
